(function () {
  'use strict';

  var TRIGGER_MARGIN = '600px'; // start fetching 600px before sentinel is visible

  function injectSpinnerCSS() {
    var style = document.createElement('style');
    style.textContent =
      '@keyframes is-spin{to{transform:rotate(360deg)}}' +
      '.infinite-scroll-spinner{display:none;text-align:center;padding:32px;grid-column:1/-1;width:100%;}' +
      '.infinite-scroll-spinner svg{animation:is-spin 0.9s linear infinite;}';
    document.head.appendChild(style);
  }

  function getNextUrl(paginationEl) {
    if (!paginationEl) return null;
    // The next-page arrow is always the LAST .pagination-custom__arr <a> tag
    var links = paginationEl.querySelectorAll('.pagination-custom__arr a');
    return links.length ? links[links.length - 1].href : null;
  }

  function init() {
    var grid        = document.querySelector('.collection__products .js-grid');
    var paginWrap   = document.querySelector('.collection__products .text-center');
    var paginEl     = document.querySelector('.collection__products .pagination-custom');

    if (!grid || !paginEl) return; // single page or not a collection

    var nextUrl = getNextUrl(paginEl);
    if (!nextUrl) return; // already on the last/only page

    // Hide the pagination widget
    if (paginWrap) paginWrap.style.display = 'none';

    // Sentinel — triggers loading when it scrolls into view
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;grid-column:1/-1;';
    grid.appendChild(sentinel);

    // Spinner shown during fetch
    var spinner = document.createElement('div');
    spinner.className = 'infinite-scroll-spinner';
    spinner.innerHTML =
      '<svg width="28" height="28" viewBox="0 0 28 28">' +
        '<circle cx="14" cy="14" r="11" stroke="#e0e0e0" stroke-width="2.5" fill="none"/>' +
        '<circle cx="14" cy="14" r="11" stroke="#1a1a1a" stroke-width="2.5" fill="none"' +
          ' stroke-dasharray="36 50" stroke-linecap="round"/>' +
      '</svg>';
    grid.appendChild(spinner);

    var loading = false;

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading || !nextUrl) return;
      loading = true;
      spinner.style.display = 'block';

      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          // Grab product cards from the next page's grid
          var remoteGrid = doc.querySelector('.collection__products .js-grid');
          if (remoteGrid) {
            Array.from(remoteGrid.children).forEach(function (item) {
              // Skip non-product rows (empty-collection message etc.)
              if (item.classList.contains('js-grid__full-row')) return;
              grid.insertBefore(item.cloneNode(true), sentinel);
            });
          }

          // Advance the next-page URL (or null if no more pages)
          var remotePagin = doc.querySelector('.collection__products .pagination-custom');
          nextUrl = getNextUrl(remotePagin);

          loading = false;
          spinner.style.display = 'none';

          if (!nextUrl) {
            observer.disconnect();
            sentinel.remove();
            spinner.remove();
          }
        })
        .catch(function () {
          loading = false;
          spinner.style.display = 'none';
        });
    }, { rootMargin: TRIGGER_MARGIN });

    observer.observe(sentinel);
  }

  injectSpinnerCSS();

  // Init after DOM ready (collection JS may run after DOMContentLoaded)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after AJAX filter / sort updates replace the product grid
  var filterTarget = document.querySelector('[data-products-grid]');
  if (filterTarget) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList') setTimeout(init, 50);
      });
    }).observe(filterTarget, { childList: true });
  }
})();
